"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrDefStrong = exports.getOrDef = exports.setIfNotUndefined = void 0;
exports.setIfNotUndefined = function (val, defaultVal) {
    return val === undefined ? defaultVal : val;
};
exports.getOrDef = function (def, other) {
    return def ? def : other;
};
exports.getOrDefStrong = function (def, other) {
    return def !== undefined || def !== null ? def : other;
};
